import { render } from "./neubauBegleitung.vue?vue&type=template&id=89549250"
import script from "./neubauBegleitung.vue?vue&type=script&lang=js"
export * from "./neubauBegleitung.vue?vue&type=script&lang=js"

import "./neubauBegleitung.vue?vue&type=style&index=0&id=89549250&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__